// Rug Plotの設定UIコンポーネント

import React from 'react';
import { GraphConfigProps, RugPlotConfig } from '../../../../types/graph-builder.types';
import { createColumnId } from '../../../../types';
import { getDateColumns } from '../../../utils/graph-builder-utils';
import * as styles from '../../../styles/components/graph-builder.css.ts';

export function RugPlotConfigComponent({
  config,
  dataset,
  onChange
}: GraphConfigProps<RugPlotConfig>) {
  // datetime型のカラムのみ取得
  const datetimeColumns = getDateColumns(dataset);

  const handleColumnChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    onChange({
      ...config,
      column: createColumnId(e.target.value)
    });
  };

  const handleShowIntensityChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange({
      ...config,
      showIntensity: e.target.checked
    });
  };

  return (
    <>
      <div className={styles.settingItem}>
        <label className={styles.settingLabel}>Date/Time Column</label>
        <select
          className={styles.settingSelect}
          value={config.column || ''}
          onChange={handleColumnChange}
        >
          <option value="">Select a column</option>
          {datetimeColumns.length === 0 ? (
            <option value="" disabled>No datetime columns available</option>
          ) : (
            datetimeColumns.map(col => (
              <option key={col.id} value={col.id}>
                {col.name}
              </option>
            ))
          )}
        </select>
      </div>

      <div className={styles.settingItem}>
        <label className={styles.settingCheckbox}>
          <input
            type="checkbox"
            checked={config.showIntensity ?? true}
            onChange={handleShowIntensityChange}
          />
          <span>Show intensity curve (moving average)</span>
        </label>
        <p className={styles.configInfo}>
          Displays event intensity over time using moving average.
          Helps identify when events are concentrated.
        </p>
      </div>
    </>
  );
}
